<div class="modal-header">
  <h4>View Proofs</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card-body p-0">
    <div class="table table-hover table-responsive table-striped table-bordered">
      <table class="table table-sm">
        <thead>
        <tr class="bg-cyan">
          <th>Sr. No.</th>
          <th>Image</th>
        </tr>
        </thead>
        <tbody *ngIf="proofs.length>0 else noItems">
        <tr *ngFor="let proof of proofs; let i = index;" class="text-center">
          <td>{{i + 1}}</td>
          <td><a target="_blank" [href]="proof.path"><img [src]="proof.path" style="width: 100px; height: 100px;"></a></td>
        </tr>
        </tbody>
        <ng-template #noItems>
        <tbody>
          <tr>
            <td colspan="2">no data found</td>
          </tr>
        </tbody>
        </ng-template>
      </table>
    </div>
  </div>
</div>

